// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_j3-0";
export var optionCard = "_j3-1";